var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11765 3H9.35294L11.4706 8.29412L8.82353 9.88235C9.95749 12.1816 11.8184 14.0425 14.1176 15.1765L15.7059 12.5294L21 14.6471V18.8824C21 19.444 20.7769 19.9826 20.3798 20.3798C19.9826 20.7769 19.444 21 18.8824 21C14.7522 20.749 10.8566 18.9951 7.93076 16.0692C5.00489 13.1434 3.25099 9.24784 3 5.11765C3 4.55601 3.22311 4.01738 3.62024 3.62024C4.01738 3.22311 4.55601 3 5.11765 3Z",
    stroke: "url(#paint0_linear_118_4427)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11765 4H8.35294L10.4706 9.29412L7.82353 10.8824C8.95749 13.1816 10.8184 15.0425 13.1176 16.1765L14.7059 13.5294L20 15.6471V19.8824C20 20.444 19.7769 20.9826 19.3798 21.3798C18.9826 21.7769 18.444 22 17.8824 22C13.7522 21.749 9.85663 19.9951 6.93076 17.0692C4.00489 14.1434 2.25099 10.2478 2 6.11765C2 5.55601 2.22311 5.01738 2.62024 4.62024C3.01738 4.22311 3.55601 4 4.11765 4Z",
    stroke: "url(#paint1_linear_118_4427)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_4427",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CCAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_4427",
    x1: 11,
    y1: 4,
    x2: 11,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CCAE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIco);
export default __webpack_public_path__ + "static/media/phone-ico.cf94095783f4213ea4fe517e1fdf7a4c.svg";
export { ForwardRef as ReactComponent };